export default "__VITE_ASSET__0ef3308d__$_?react__"